import axios from 'axios'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

export const useData = () => {
    const [name, setName] = useState("")

    useEffect(() => {
        const abortCont = new AbortController()
        
        axios.get(process.env.REACT_APP_API_URL + "/data", {
            signal: abortCont.signal
        })
        .then(res => {
            let data = res.data
            setName(data.name)
        }).catch(err => {
            if(err.message === "canceled") {
                return
            }
            toast.error("Could not load server data.")
        })
    
        return () => abortCont.abort()
    })

    return { name, setName }
}

export const getStatusOptions = () => {
    return [
        {
            value: 'New',
            label: 'New',
            icon: 'fas fa-plus',
            small: false
        },
        {
            value: 'MeetingBooked',
            label: 'Meeting booked',
            icon: 'fas fa-handshake',
            small: false
        },
        {
            value: 'FollowUp',
            label: 'Follow-up',
            icon: 'fas fa-person-circle-plus',
            small: false
        },
        {
            value: 'Waiting',
            label: 'Waiting',
            icon: 'fas fa-pause',
            small: false
        },
        {
            value: 'Sold',
            label: 'Sold',
            icon: 'fas fa-money-bill',
            small: true
        },
        {
            value: 'Done',
            label: 'Done',
            icon: 'fas fa-money-bill',
            small: true
        },
        {
            value: 'Lost',
            label: 'Lost',
            icon: 'fas fa-person-circle-exclamation',
            small: true
        },
        {
            value: 'LostBeforeMeeting',
            label: 'Lost before meeting',
            icon: 'fas fa-person-circle-exclamation',
            small: true
        },
        {
            value: 'NoShow',
            label: 'No Show',
            icon: 'fas fa-eye',
            small: true
        }
    ]
}
